import { ApiClient, ApiOrder } from "lib/api";

type UpdateCallback = (orders: ApiOrder[]) => void;

export default class UpdateService {
  private listener?: UpdateCallback;
  private api: ApiClient;
  private ids: string[] = [];
  private timer: NodeJS.Timeout | undefined = undefined;

  constructor(api: ApiClient, listener: UpdateCallback) {
    this.listener = listener;
    this.api = api;
  }

  public update(id: string) {
    this.ids.push(id);
    if (this.timer) {
      return;
    }
    this.timer = setTimeout(() => {
      this.asyncUpdate();
    }, 100);
  }

  public dispose() {
    this.listener = undefined;
  }

  private asyncUpdate() {
    if (this.ids.length === 0) {
      this.timer = undefined;
      return;
    }
    const ids = this.ids.splice(0, this.ids.length);
    this.api
      .GET("/api/orders", {
        params: {
          query: {
            ids,
          },
        },
      })
      .then((r) => {
        if (r.error) {
          console.error(r.error);
          return;
        }
        if (this.listener) {
          this.listener(r.data.items);
          this.timer = setTimeout(() => {
            this.asyncUpdate();
          }, 100);
        }
      });
  }
}
